import React from 'react';
import {AvForm} from 'availity-reactstrap-validation';
import ProductPriceColumn from "../../shared/component/dataTable/columns/ProductPriceColumn.json";
import ProductService from "../../shared/service/ProductService";
import GeneralUtils from "../../shared/utils/GeneralUtils";
import Dialog from "../../shared/component/dialog/Dialog";
import DataTable from "../../shared/component/dataTable/DataTable";
import {InputText} from "primereact/inputtext";
import DepartmentFilter from "./DepartmentFilter";
import ProductPriceSave from "./ProductPriceSave";
import '../../shared/styles/SettingsPage.css';

export default class ProductPriceList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.productService = new ProductService();
    }

    componentDidMount() {
        this.refresh();
    }

    renderFilter() {
        return (
            <div className="settings-page__filter settings-page__filter--lookup">
                <span className="p-input-icon-right p-input-icon-right--triple settings-page__lookup-wrap">
                    <InputText
                        className="settings-page__lookup-input"
                        disabled
                        value={this.state.departmentName}
                        placeholder="Select Department"
                        onClick={() => this.setState({displayDialogFilter: true})}/>
                    <i
                        className="pi pi-search"
                        style={{cursor: "pointer"}}
                        onClick={() => this.setState({displayDialogFilter: true})}
                    />
                    <i
                        className="pi pi-times"
                        style={{cursor: "pointer"}}
                        onClick={() => {
                            this.setState({departmentId: null, departmentName: ''});
                        }}
                    />
                    <i
                        className="pi pi-refresh"
                        style={{cursor: "pointer"}}
                        onClick={() => {
                            this.refDataTable.dt.filter(this.state.departmentId, "department.id", "equals");
                            let filterElement = this.refDataTable.state.filterElement;
                            filterElement["department.id"] = this.state.departmentId;
                            this.refDataTable.setState({filterElement: filterElement});
                            this.refDataTable.onModelFilterChangeWithNameAndValue("department.id", this.state.departmentId, "long");
                        }}
                    />
                </span>

                <Dialog visible={this.state.displayDialogFilter}
                        header={"Department"}
                        onHide={() => this.setState({displayDialogFilter: false})}
                        style={GeneralUtils.getDialogStyleForDepartmentFilter()}>
                    <DepartmentFilter
                        ref={(elem) => this.refModelCredentialsSave = elem}
                        onDataSelect={this.onDataSelectFilter}
                        closeDisplayDialog={this.closeDisplayDialogFilter}/>
                </Dialog>
            </div>
        );
    }

    refresh() {
        this.refDataTable.refresh();
    }

    render() {
        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm>
                    <div className="settings-page__shell">
                        <div className="settings-page__header">
                            <h1 className="settings-page__title">Product Price</h1>
                        </div>
                        <div className="settings-page__panel">
                            {this.renderFilter()}
                            {this.productList()}
                        </div>
                    </div>
                </AvForm>
            </div>
        );
    }

    productList() {
        var url = "product/product/all";

        return (
            <div className="settings-page__section">
                <Dialog visible={this.state.displayDialog}
                        header={""}
                        onHide={() => this.setState({displayDialog: false})}
                        style={GeneralUtils.getDialogStyleForProduct()}>
                    <ProductPriceSave ref={(elem) => this.refModelSave = elem}
                                      refreshDataTable={this.refreshDataTable}
                                      closeDisplayDialog={this.closeDisplayDialog}/>
                </Dialog>

                {GeneralUtils.checkPrivilege("put_product/product/all") &&
                    <div className="settings-page__table-wrap">
                        <DataTable ref={(elem) => this.refDataTable = elem} fields={ProductPriceColumn.fields}
                                   objectName={ProductPriceColumn.name}
                                   dataURL={url}
                                   selectionMode="single" onDataSelect={this.onDataSelect}
                                   loading={this.state.loading}/>
                    </div>}
            </div>
        );
    }

    onDataSelect = (data) => {
        GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => ref.setData(data));
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    refreshDataTable = () => {
        this.closeDisplayDialog();
        this.refDataTable.refresh();
    }

    closeDisplayDialogFilter = () => {
        this.setState({displayDialogFilter: false});
    }

    onDataSelectFilter = (data) => {
        this.setState({
            departmentId: data.id,
            departmentName: data.name,
            displayDialogFilter: false
        });
    }
}
